import React from 'react'
import './styles.scss'

import Button from '../../../components/Button'

import SigningContract from '../../../assets/svgs/SigningContract'
import WhatsappButton from '../../../components/WhatsappButton'
import COLORS from 'styles/colors'

interface IPropType {
  onClick: () => void
}

export default function CreateContractInfo({ onClick }: IPropType) {
  return (
    <div className='create-contract-info-container'>
      <p>Precisando de um contrato de aluguel?</p>
      <p>
        Use o nosso gerador de contrato de aluguel com assinatura eletrônica valido juridicamente por apenas {' '}
        <b>R$ 10,00</b> cada contrato!
      </p>

      <div className='contract-margin'>
        <SigningContract aria-label={'Contrato sendo assinado'} />
      </div>

      <p>
        Ele foi criado pelos melhores advogados da área imobiliária, que conseguiram criar um contrato de
        aluguel objetivo, claro e sem juridiquês.
      </p>

      <p style={{ marginBottom: 4 }}>Gostaria de ler as cláusulas do contrato de aluguel?</p>
      <a
        style={{ color: COLORS.greyscale.dark }}
        target='_blank'
        rel='noopener noreferrer'
        href='https://rebrand.ly/saibamaismellro'
      >
        Clique aqui e leia.
      </a>

      <p style={{ marginBottom: 4 }}>O Link para pagamento vai aparecer no final do processo.</p>
      <a
        style={{ color: COLORS.greyscale.dark }}
        target='_blank'
        rel='noopener noreferrer'
        href='https://mellro.com/sou-proprietarioa/gerador-de-contratos-de-aluguel/'
      >
        Saiba mais como funciona aqui
      </a>

      <div className='buttons-container home-contract-buttons'>
        <WhatsappButton />
        <Button title={'Comprar'} onClick={onClick} className='margin-bottom' />
      </div>
    </div>
  )
}
